import React from 'react';
import Grid from '@material-ui/core/Grid';
import MDXParser from '../mdxParser';
import Typography from '@material-ui/core/Typography';
import Img from '../wrappedImage';
import clsx from 'clsx';
import { useStaticQuery, graphql } from 'gatsby';
import Container from '@material-ui/core/Container';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

// Content
import BringingHope from '../../sections/BringingHope/BringingHope';
import ESSNSectionTwo from '../../sections/BringingHope/ESSNTwo';

import ESSNSection from '../../sections/BringingHope/ESSN';

import IncredibleOrdinary from '../../sections/BringingHope/IncredibleOrdinary';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: '60px 0',
    },
    title: {
      textAlign: 'center',
      color: 'white',
      fontWeight: 'bold',
      padding: '20px 0px',
    },
    rootDetail: {},
    text: {
      padding: '0px 20px',
      display: 'flex',
      backgroundColor: 'transparent',
      flexDirection: 'column',
      boxShadow: 'none',
      borderRadius: '0px',
    },
    image: {
      width: '100%',
      height: 'auto',
    },
    imageContainer: {
      backgroundColor: 'transparent',
      display: 'flex',
      flexDirection: 'column',
      boxShadow: 'none',
    },
    essn: {
      backgroundColor: '#034ea1',
      padding: '20px',
    },

    super: {
      color: 'white',
      fontWeight: 'bold',
      textAlign: 'center',
      padding: '20px 0px',
      marginTop: 'auto'
    },
    body: {
      color: 'white',
      textAlign: 'center',
      padding: '10px 20px',
    },
    container: {
      flexDirection: 'column',
      justifyContent: 'flex-end',
      display: 'flex',
      [theme.breakpoints.up('sm')]: {
        borderRight: '1px dashed white',
      },
      borderRight: '0px'
    },
    noBorder: {
      borderRight: 'none',
    },
    incredibleText: {
      padding: '40px 0',
    },
  }),
);

type Props = { children: React.ReactNode; image: string };

const ESSN = () => {
  const classes = useStyles();

  const [ref, inView] = useInView({
    threshold: 0,
  });

  return (
    <Grid container spacing={0} className={classes.essn} ref={ref}>
      <Grid item xs={12} md={12}>
        <Typography variant="h4" className={classes.title}>
          Thanks to the ESSN Programme
        </Typography>
      </Grid>

      <Grid item xs={12} md={3} className={classes.container}>
        <Typography variant="body1" className={classes.body}>
          The percentage of families assisted by the ESSN that could afford diets meeting minimum acceptable food security standards was
        </Typography>

        <Typography variant="h1" className={classes.super}>
          {inView && <CountUp delay={0} end={97} suffix="%" />}
        </Typography>
      </Grid>
      <Grid item xs={12} md={3} className={classes.container}>
        <Typography variant="body1" className={classes.body} style={{ padding: '10px 40px'}}>
          The percentage of people saying they were able to cover all their basic needs went up from
          25% to
        </Typography>
        <Typography variant="h1" className={classes.super}>
          {inView && <CountUp delay={0} end={50} suffix="%" />}
        </Typography>
      </Grid>
      <Grid item xs={12} md={3} className={classes.container}>
        <Typography variant="body1" className={classes.body} style={{ padding: '10px 70px'}}>
          The number of children that had to work to help bring in money dropped by
        </Typography>
        <Typography variant="h1" className={classes.super}>
          {inView && <CountUp delay={0} end={41} suffix="%" />}
        </Typography>
      </Grid>
      <Grid item xs={12} md={3} className={clsx(classes.container, classes.noBorder)}>
        <Typography variant="body1" className={classes.body} style={{ padding: '10px 50px'}}>
          The number of beneficiaries who had been forced to cut back om health spending fell by
        </Typography>
        <Typography variant="h1" className={classes.super}>
          {inView && <CountUp delay={0} end={35} suffix="%" />}
        </Typography>
      </Grid>
    </Grid>
  );
};

const BringingHopeSection = () => {
  const classes = useStyles();

  const data = useStaticQuery(graphql`
    query {
      turkey: file(relativePath: { eq: "turkey.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }

      incredible: file(relativePath: { eq: "IMG_0064.jpg" }) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <>
      <Container maxWidth={false} disableGutters={true}>
        <Container>
          <div className={classes.root}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12}>
                <MDXParser>
                  <BringingHope />
                </MDXParser>
              </Grid>
              <Grid item xs={12} md={12}>
                <Img
                  fluid={data.turkey.childImageSharp.fluid}
                  className={classes.image}
                  alt="Image"
                  copyText='Deniz Akkus'
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <MDXParser>
                  <ESSNSection />
                </MDXParser>
              </Grid>

              <Grid item xs={12} md={6}>
                <MDXParser>
                  <ESSNSectionTwo />
                </MDXParser>
              </Grid>
            </Grid>
          </div>
        </Container>
      </Container>

      <Container maxWidth={false} disableGutters={true} className={classes.essn}>
        <Container>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12}>
              <ESSN />
            </Grid>
          </Grid>
        </Container>
      </Container>
      <Container maxWidth={false} disableGutters={true}>
        <Container>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Img
                fluid={data.incredible.childImageSharp.fluid}
                className={classes.image}
                alt="Image"
                copyText='WFP – funded by the European Union'
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <div className={classes.incredibleText}>
                <MDXParser>
                  <IncredibleOrdinary />
                </MDXParser>
              </div>
            </Grid>
          </Grid>
        </Container>
      </Container>
    </>
  );
};

export default BringingHopeSection;
